import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-20 pb-12 md:pb-16" data-id="element-79">
      <div className="max-w-[1200px] mx-auto" data-id="element-80">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-81">
          {/* Left Column */}
          <div className="flex-1" data-id="element-82">
            <div className="flex items-center mb-4" data-id="element-83">
              <span className="font-display font-bold text-[13px] text-arena" style={{
              letterSpacing: '0.08em'
            }} data-id="element-84">
                ORIGEN
              </span>
              <span className="font-display font-semibold text-[13px] text-arena/60 ml-1" style={{
              letterSpacing: '0.08em'
            }} data-id="element-85">
                STUDIO
              </span>
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-86">
              Construimos sitios web estratégicos para empresas B2B basados en
              el diagnóstico ICD™.
            </p>
          </div>

          {/* Right Column */}
          <div className="flex-1 md:max-w-[400px]" data-id="element-87">
            <div className="flex flex-wrap gap-x-6 gap-y-4" data-id="element-88">
              <a href="#metodologia" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-89">
                Metodología
              </a>
              <a href="#casos" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-90">
                Casos
              </a>
              <Link to="/diagnostico" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-91">
                Diagnóstico
              </Link>
              <a href="#inteligencia" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-92">
                Inteligencia Digital
              </a>
              <a href="#" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-93">
                LinkedIn
              </a>
              <a href="#" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-94">
                Instagram
              </a>
              <a href="#" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-95">
                WhatsApp
              </a>
              <a href="mailto:hola@origenstudioco.com" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-96">
                hola@origenstudioco.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-97">
          <p className="font-body text-[12px] text-arena/30" data-id="element-98">
            © 2025 Origen Studio · Colombia
          </p>
        </div>
      </div>
    </footer>;
}